import { atom, createStore } from 'jotai'
import { Provider } from '@/store';
import { ReactNode } from 'react';

const store = createStore();

export const AppContainer = ({ children }:{ children: ReactNode }) => {
  return (
    <Provider store={store}>{children}</Provider>
  )
}